// generatePanelHost — how the content browser's Generate-body-animation panel
// reaches its OWN docked region in the shell, to the right of the inspector.
//
// Same mechanics as assetInspectorHost (the region registers a host element and
// the ContentBrowser portals into it, so all the generate/save state stays owned
// by the content browser and only the DOM moves) — but deliberately a SEPARATE
// rendezvous, because the two panels answer different questions and must be able
// to be on screen at once.
//
// That distinction cost a shipped regression: the Generate panel first portalled
// into assetInspectorHost, on the reasoning that the shell has ONE details panel
// fed by whatever was selected last. The DCC rule is real, but it is about
// SELECTION — an outliner node and a content-browser asset are two sources of
// one selection concept, so they evict each other. A generate session is not a
// selection: it is an authoring task that runs for tens of seconds, and the
// Modify flow starts FROM a selected clip whose properties you then could not
// read, because the wizard was standing where they render. Hence its own region.
//
// Unlike the inspector bridge there is no clear()/mutual-exclusion handshake:
// nothing evicts a generate session but closing it.

let _targetEl = null
let _active = false
const listeners = new Set()

function notify() {
  for (const fn of listeners) fn()
}

export const generatePanelHost = {
  /** The shell region registers its portal target here (null on unmount). */
  registerTarget(el) {
    _targetEl = el
    notify()
  },

  getTarget() { return _targetEl },

  /**
   * ContentBrowser raises this while a generate session is open AND docked.
   * The region's very existence is derived from it — false means the region
   * does not render at all, so there is no empty strip and no stray resize
   * handle for a panel nobody opened.
   */
  setActive(on) {
    if (_active === !!on) return
    _active = !!on
    notify()
  },

  isActive() { return _active },

  subscribe(fn) {
    listeners.add(fn)
    fn()
    return () => listeners.delete(fn)
  },

  /** Test seam. */
  _reset() {
    _targetEl = null
    _active = false
    listeners.clear()
  },
}

export default generatePanelHost
